import { render } from "./necklaceDiamondIcon.vue?vue&type=template&id=1a84cc02"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__